import { render, staticRenderFns } from "./InventoryCard.vue?vue&type=template&id=4eed930e&scoped=true&"
import script from "./InventoryCard.vue?vue&type=script&lang=js&"
export * from "./InventoryCard.vue?vue&type=script&lang=js&"
import style0 from "./InventoryCard.vue?vue&type=style&index=0&id=4eed930e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eed930e",
  null
  
)

export default component.exports